import { render, staticRenderFns } from "./RejectRequestsFilterDialogForCustomerService.vue?vue&type=template&id=6779d7bc&"
import script from "./RejectRequestsFilterDialogForCustomerService.vue?vue&type=script&lang=js&"
export * from "./RejectRequestsFilterDialogForCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports